import { connect } from 'react-redux';
import Party from 'components/parties/Party';
import {
  deleteParty,
  fetchParty,
  updateParty,
  enableDisableParty,
} from 'data/parties/Parties.actions';
import { resetPassword } from 'data/app/App.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      party: state.parties.currentParty,
      partyAppMemberships: state.parties.partyAppMembershipsData,

      submitting:
        state.parties.deletingParty ||
        state.parties.creatingParty ||
        state.parties.changingStatusParty ||
        state.parties.updatingParty,
      user: state.app.user,
    },
    state,
    'countries',
    'partyTypes',
    'regions',
    'taxOffices',
    'applications',
    'memberships',
    'insurances'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchParty: partyId => dispatch(fetchParty(partyId)),
    updateParty: partyData => dispatch(updateParty(partyData)),
    deleteParty: partyId => dispatch(deleteParty(partyId)),
    enableDisableParty: partyId => dispatch(enableDisableParty(partyId)),
    resetPassword: partyId => dispatch(resetPassword(partyId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Party);
